import React from "react";
import ChangePageTitle from "../components/change-title-page";
import Reserve_content from "../components/component-reserve";


function Reserve(){

    return(
        <>
            <ChangePageTitle pageTitle="رزرو میز | رستوران باغبان" />
            <Reserve_content />
        </>
    );

}

export default Reserve;